export enum ClaimStatus {
  Active = 0,
  Complete = 1,
  Dropped = 2,
}
